
const getEditableQuestions = (questions = [], tenant) => {
  return questions.filter(({tenantUuid}) => (tenant === tenantUuid))
}

export default getEditableQuestions
